export const FIREBASE_API_KEY = 'AIzaSyCCdo1fsQp5EhsAwuzKGrBOhpITGCNX_0I';
export const FIREBASE_AUTH_DOMAIN = 'twdt-prod.firebaseapp.com';
export const FIREBASE_DATABASE_URL = 'https://twdt-prod.firebaseio.com';
export const FIREBASE_PROJECT_ID = 'twdt-prod';
export const FIREBASE_STORAGE_BUCKET = 'twdt-prod.appspot.com';
export const FIREBASE_MESSAGING_SENDER_ID = '225355474221';

export const TW_API_URL = 'https://trenchwars.org/api';

export const SEASON_ID = '2020-winter'; // the tblDraft__Season.fcSeasonID field, used by the API
export const SEASON_NAME = 'Season 20';
export const CURRENT_WEEK = 1;
export const REGULAR_SEASON_WEEKS = 7;
export const LOGO_IMG = 'https://i.imgur.com/KzzGxbH.png';
export const NO_TEAM_IMG = 'https://i.imgur.com/yxkQzsw.png';
// 'https://firebasestorage.googleapis.com/v0/b/twl-prod.appspot.com/o/seasons%2F22%2Fteams%2Fnone.png?alt=media&token=7cc7d884-578e-4ff6-a32c-863187131a23';
export const FORUMS_URL = 'https://forums.trenchwars.com/twdt';
export const RULES_URL =
  'https://forums.trenchwars.com/twdt/1357516-twdt-season-24-rules';
export const DRAFT_URL =
  'https://docs.google.com/spreadsheets/d/1Jtw0EaZTVVoqyNrKn-Of0MBBIEtMXaOgonb1njt2AE4/edit#gid=1246217745';

const TEAMS = [
  235, // Malevolent,
  236, // Snakecharmer,
  237, // Power
  238, // Treyway
  239, // Kickers
  240, // Crusaders
  241, // Phoenix
  242, // Prayer
  243, // Terrorist
  244, // Win or Die
];

export const TEAM_PARTICIPATION = {
  twdtd: TEAMS,
  twdtj: TEAMS,
  twdtb: TEAMS,
};



// WEBPACK FOOTER //
// ./src/config.js